<template>
    <v-expansion-panels
        v-model="panel"
        class="expansion-panel"
    >
        <v-expansion-panel>
            <v-expansion-panel-header class="card-title-2 mt-1">
                <div class="filters-panel">
                    <div class="filter-buttons">
                        <div class="filter-buttons-title">
                            <span class="mx-2 stylish-title">Αναθέσεις</span>
                        </div>
                        <div class="filter-buttons-selections">
                            <v-btn
                                icon
                                large
                                elevation="2"
                                class="mx-1 always-elevated-btn"
                                @click.stop="togglePanel()"
                            >
                                <v-icon v-if="assignmentViewPreference === 'array'" :color="theming.cardsAndTablesText || 'black'" class="mx-2 change-view-icon" @click.stop="changeView()" medium>
                                    mdi-view-day
                                </v-icon>
                                <v-icon v-else :color="theming.cardsAndTablesText || 'black'" class="mx-2 change-view-icon" @click.stop="changeView()" medium>
                                    mdi-table
                                </v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                large
                                elevation="2"
                                class="mx-1 always-elevated-btn"
                                @click.stop="togglePanel()"
                            >
                                <v-icon medium class="filter-icon" :color="filterToSave && Object.keys(filterToSave).length > 0 && !selectedPresetFilter ? '#febf15' : (theming.cardsAndTablesText || 'black')">
                                    mdi-filter-variant
                                </v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                large
                                elevation="2"
                                class="mx-1 always-elevated-btn"
                                @click.stop="toggleClearButton()"
                            >
                                <v-icon class="filter-remove" medium :color="theming.cardsAndTablesText || 'black'">
                                    mdi-filter-variant-remove
                                </v-icon>
                            </v-btn>
                            <filter-preset-selection :userPresets="userFilterPresets" :selectedPreset="selectedPresetFilter" @apply-filter="onApplyFilterPreset" @delete-filter="getCurrentUser" />
                            <filter-preset-creation
                                :filter="filterToSave || {}"
                                :sort="sort"
                                @filter-saved="getCurrentUser"
                            />
                        </div>
                    </div>
                    <div v-if="['selectionSearch', 'freeSearch'].includes(this.tabs[selectedTab].value)" @click.stop="" class="sort-wrapper">
                        <div v-if="this.sortBy" @click.stop="toggleSortType">
                            <v-icon v-if="sortType === 'ASC'" :color="theming.cardsAndTablesText || 'black'">mdi-sort-alphabetical-ascending</v-icon>
                            <v-icon v-else :color="theming.cardsAndTablesText || 'black'">mdi-sort-alphabetical-descending</v-icon>
                        </div>
                        <v-select
                            v-model="sortBy"
                            :items="this.tabs[selectedTab].value === 'freeSearch' ? freeSearchSortSelections : sortSelections"
                            item-text="text"
                            item-value="value"
                            label="Sort by"
                            class="sort-by-selection"
                            @change="onSearch"
                            clearable
                        ></v-select>
                    </div>
                    <div v-if="containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR'], userRoles)" class="create-new">
                        <v-btn class="my-2 mr-2" dark small color="black" @click="createAssignment">
                            <v-icon dark>mdi-plus</v-icon>ΔΗΜΙΟΥΡΓΙΑ ΝΕΑΣ
                        </v-btn>
                    </div>
                </div>
            </v-expansion-panel-header>
            <v-divider/>
            <v-expansion-panel-content>
                <v-tabs
                    v-model="selectedTab"
                    fixed-tabs
                    dark
                >
                    <v-tabs-slider color="#FFC000"></v-tabs-slider>
                    <v-tab v-for="tab in this.tabs" :key="tab.value" :disabled="shouldTabBeDisabled(tab)" @click="selectTab">
                        {{ tab.text }}
                    </v-tab>
                </v-tabs>
                <v-system-bar
                    v-if="selectedPresetFilter && config.hasUserFilterPresets"
                    lights-out
                    dark
                    class="selected-preset-filter">
                    <v-icon color="#febf15">mdi-filter-variant</v-icon>
                    Επιλεγμένο Φίλτρο: <div class="selected-preset-filter-text">{{ selectedPresetFilter.name }}</div>
                </v-system-bar>
                <div v-if="this.tabs[selectedTab].value === 'freeSearch'">
                    <div class="like-search-wrapper">
                        <v-text-field
                            v-model="filter.sr"
                            label="SR"
                            type="text"
                            class="filter-field sr"
                            clearable
                            @input="likeFieldTriggered"
                        >
                            <template v-slot:prepend-inner>
                                <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-text-search-variant</v-icon>
                            </template>
                        </v-text-field>
                        <v-text-field
                            v-model="filter.clientName"
                            label="Ονοματεπώνυμο Πελάτη"
                            type="text"
                            class="filter-field client-name"
                            :disabled="!!this.filter.sr"
                            clearable
                            @input="likeFieldTriggered"
                        >
                            <template v-slot:prepend-inner>
                                <v-icon :color="'#BF9626'">mdi-account</v-icon>
                            </template>
                        </v-text-field>
                    </div>
                    <div class="like-search-wrapper">
                        <v-text-field
                            v-model="filter.buildingId"
                            label="Building ID"
                            type="text"
                            class="filter-field building-id"
                            clearable
                            :disabled="!!this.filter.sr"
                            @input="likeFieldTriggered"
                        >
                            <template v-slot:prepend-inner>
                                <v-icon :color="'#284078'">mdi-domain</v-icon>
                            </template>
                        </v-text-field>
                        <v-text-field
                            v-model="filter.address"
                            label="Διεύθυνση"
                            type="text"
                            class="filter-field address"
                            clearable
                            :disabled="!!this.filter.sr"
                            @input="likeFieldTriggered"
                        >
                            <template v-slot:prepend-inner>
                                <v-icon :color="'rgb(138, 0, 0)'">mdi-map-marker</v-icon>
                            </template>
                        </v-text-field>
                    </div>
                    <div class="search-button-wrapper">
                        <v-btn v-if="containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR'], userRoles)" class="mx-2 white--text search-btn-hover" medium color="black" @click="onExport" :loading="exportLoading">
                            <v-icon medium class="bulding-id-icon">mdi-download</v-icon> Export
                        </v-btn>
                    </div>
                </div>
                <div v-else-if="this.tabs[selectedTab].value === 'selectionSearch'">
                    <div class="assignment-filters">
                        <v-select
                            v-if="isAdminOrCompanyCoordinator && clients.length > 1"
                            v-model="filter.client"
                            :items="clients"
                            :color="theming.cardsAndTablesText || 'black'"
                            item-value="id"
                            item-text="name"
                            label="Πάροχος"
                            clearable
                            outlined
                            @change="onClientSelect"
                            class="selection-field"
                            :disabled="disabled"
                        ></v-select>
                        <v-select
                            v-if="isAdminOrCompanyCoordinator && assignorsContractors.length > 1"
                            v-model="filter.contractorFrom"
                            :items="assignorsContractors"
                            item-value="id"
                            item-text="name"
                            label="Από Εργολάβο"
                            clearable
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-menu
                            v-if="isAdminOrCompanyCoordinator"
                            v-model="createdAtMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            class="filter-field"
                            :disabled="disabled"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="filterCreatedAtDateText"
                                    class="filter-field calendar"
                                    label="Δημιουργήθηκε"
                                    readonly
                                    clearable
                                    outlined
                                    @click:clear="filterCreatedAtDateRange = []"
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="disabled"
                                >
                                    <template v-slot:prepend-inner>
                                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filterCreatedAtDateRange"
                                range
                                color="#0047AB"
                                locale="el"
                                @change="filterCreatedAtDateSelected"
                                @input="() => { if (filterCreatedAtDateRange.length === 2) { createdAtMenu = false }}"
                                :disabled="disabled"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                            v-if="isAdminOrCompanyCoordinator"
                            v-model="completedAtMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            class="filter-field"
                            :disabled="disabled"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="filterCompletedAtDateText"
                                    class="filter-field calendar"
                                    label="Ολοκληρώθηκε"
                                    readonly
                                    clearable
                                    outlined
                                    @click:clear="filterCompletedAtDateRange = []"
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="disabled"
                                >
                                    <template v-slot:prepend-inner>
                                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filterCompletedAtDateRange"
                                range
                                color="#0047AB"
                                locale="el"
                                @change="filterCompletedAtDateSelected"
                                @input="() => { if (filterCompletedAtDateRange.length === 2) { completedAtMenu = false }}"
                                :disabled="disabled"
                            ></v-date-picker>
                        </v-menu>
                        <v-select
                            v-model="filter.status"
                            :items="status"
                            item-value="value"
                            item-text="name"
                            clearable
                            label="Status"
                            outlined
                            multiple
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                    class="font-weight-bold white--text"
                                    :color="data.item.color"
                                >
                                    <v-icon>{{ data.item.icon }}</v-icon>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                        </v-select>
                        <v-select
                            v-if="isAdminOrCompanyCoordinator"
                            v-model="filter.contractor"
                            :items="assigneesContractors"
                            item-value="id"
                            item-text="name"
                            label="Ανατεθειμένος Εργολάβος"
                            clearable
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            class="filter-field"
                            :disabled="disabled"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="filterDateText"
                                    class="filter-field calendar"
                                    label="Ανατέθηκε σε Εργολάβο"
                                    readonly
                                    clearable
                                    outlined
                                    @click:clear="filterDateRange = []"
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="disabled"
                                >
                                    <template v-slot:prepend-inner>
                                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filterDateRange"
                                range
                                color="#0047AB"
                                locale="el"
                                @change="filterDateSelected"
                                @input="() => { if (filterDateRange.length === 2) { menu = false }}"
                                :disabled="disabled"
                            ></v-date-picker>
                        </v-menu>
                        <v-select
                            v-model="backOfficeFilterSelection"
                            :items="backOfficeStages"
                            item-value="value"
                            item-text="name"
                            multiple
                            clearable
                            label="Back Office (Μη ολοκληρωμένα)"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                    class="font-weight-bold"
                                >
                                    <span class="font-weight-bold">{{ data.item.name }}</span>
                                </v-chip>
                            </template>
                        </v-select>
                        <v-autocomplete
                            v-model="filter.location"
                            clearable
                            chips
                            label="Περιοχές"
                            item-value="id"
                            item-text="name"
                            :items="locations"
                            class="locations"
                            multiple
                            :disabled="disabled"
                            outlined
                        ></v-autocomplete>
                        <v-autocomplete
                            v-model="filter.aks"
                            clearable
                            chips
                            label="Α/Κ"
                            item-value="id"
                            item-text="name"
                            :items="aks"
                            class="locations"
                            multiple
                            :disabled="disabled"
                            outlined
                        ></v-autocomplete>
                        <v-select
                            v-model="filter.type"
                            :items="types"
                            item-value="value"
                            item-text="name"
                            clearable
                            label="Τύπος"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                            @change="onTypeChange"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="this.filter.type === 'LAST_DROP'"
                            v-model="filter.lastDropWholebuy"
                            :items="booleanOptions"
                            clearable
                            label="Wholebuy"
                            item-value="value"
                            item-text="text"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="this.filter.type === 'LAST_DROP'"
                            v-model="filter.lastDropEnrichment"
                            :items="booleanOptions"
                            clearable
                            label="Εμπλουτισμός"
                            item-value="value"
                            item-text="text"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="this.filter.type === 'LAST_DROP'"
                            v-model="filter.lastDropDoubleCrew"
                            :items="booleanOptions"
                            clearable
                            label="Διπλό Συνεργείο"
                            item-value="value"
                            item-text="text"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="['PILOT', 'PILOT_UFBB', 'MALFUNCTION'].includes(this.filter.type)"
                            v-model="filter.excavationDemand"
                            :items="booleanOptions"
                            clearable
                            label="Αίτηση Εκσκαφής"
                            item-value="value"
                            item-text="text"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="['PILOT', 'PILOT_UFBB', 'MALFUNCTION'].includes(this.filter.type)"
                            v-model="filter.excavationPermitted"
                            :items="booleanOptions"
                            clearable
                            label="Άδεια Εκσκαφής"
                            item-value="value"
                            item-text="text"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="['PILOT', 'PILOT_UFBB', 'MALFUNCTION'].includes(this.filter.type)"
                            v-model="filter.prodesmeusiDifference"
                            :items="prodesmeusiDifferenceStages"
                            item-value="value"
                            item-text="name"
                            clearable
                            label="Διαφορά Προδέσμευσης"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="'PILOT' === this.filter.type"
                            v-model="filter.smartReadiness"
                            :items="booleanOptions"
                            item-text="text"
                            item-value="value"
                            clearable
                            label="Smart Readiness"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="'PILOT' === this.filter.type && this.filter.smartReadiness"
                            v-model="filter.secondTimeSmartReadiness"
                            :items="booleanOptions"
                            clearable
                            label="Δεύτερη φορά Smart Readiness"
                            item-value="value"
                            item-text="text"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="['PILOT', 'PILOT_UFBB', 'MALFUNCTION'].includes(this.filter.type)"
                            v-model="filter.constructionPermitted"
                            :items="booleanOptions"
                            clearable
                            label="Έγκριση Κατασκευής"
                            item-value="value"
                            item-text="text"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-model="filter.notFromImport"
                            :items="booleanOptions"
                            clearable
                            label="Εξωσυστημική"
                            item-value="value"
                            item-text="text"
                            outlined
                            class="selection-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.text }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if="['PILOT', 'PILOT_UFBB'].includes(this.filter.type) && autopsyStatuses.length > 1"
                            v-model="filter.autopsy.status"
                            :items="autopsyStatuses"
                            item-value="value"
                            item-text="name"
                            :label="statusLabel('Αυτοψία', 'autopsy')"
                            clearable
                            outlined
                            class="selection-field status-field"
                            :disabled="disabled"
                            @change="(e) => { if (!e) { deleteFromCompletedRanges('autopsy') } }"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                                <completed-date-range-btn :from="'autopsy'" :label="'Αυτοψίας'" :status="data.item.value" @selected="updateCompletedRanges" :completed-range="filter['autopsy']?.completedRange || {}"/>
                            </template>
                        </v-select>
                        <v-select
                            v-if="['PILOT', 'PILOT_UFBB'].includes(this.filter.type) && this.filter.autopsy.status === 'STARTED' && autopsyStatuses.length > 1"
                            v-model="filter.autopsy.subStatus"
                            :items="autopsySubStatuses"
                            item-value="value"
                            item-text="name"
                            label="Αυτοψία Substatus"
                            clearable
                            outlined
                            class="selection-field status-field"
                            :disabled="disabled"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'MALFUNCTION'].includes(this.filter.type) && earthworkStatuses.length > 1"
                            v-model="filter.earthwork.status"
                            :items="earthworkStatuses"
                            item-value="value"
                            item-text="name"
                            :label="statusLabel('Χωματουργικά', 'earthwork')"
                            clearable
                            outlined
                            class="selection-field status-field"
                            :disabled="disabled"
                            @change="(e) => { if (!e) { deleteFromCompletedRanges('earthwork') } }"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                                <completed-date-range-btn :from="'earthwork'" :label="'Χωματουργικών'" :status="data.item.value" @selected="updateCompletedRanges" :completed-range="filter['earthwork']?.completedRange || {}"/>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'MALFUNCTION'].includes(this.filter.type) && blowingStatuses.length > 1"
                            v-model="filter.blowing.status"
                            :items="blowingStatuses"
                            item-value="value"
                            item-text="name"
                            :label="statusLabel('Εμφύσηση', 'blowing')"
                            clearable
                            outlined
                            class="selection-field status-field"
                            :disabled="disabled"
                            @change="(e) => { if (!e) { deleteFromCompletedRanges('blowing') } }"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                                <completed-date-range-btn :from="'blowing'" :label="'Εμφύσησης'" :status="data.item.value" @selected="updateCompletedRanges" :completed-range="filter['blowing']?.completedRange || {}"/>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'MALFUNCTION'].includes(this.filter.type) && constructionStatuses.length > 1"
                            v-model="filter.construction.status"
                            :items="constructionStatuses"
                            item-value="value"
                            item-text="name"
                            :label="statusLabel('Κατασκευή', 'construction')"
                            clearable
                            outlined
                            class="selection-field status-field"
                            :disabled="disabled"
                            @change="(e) => { if (!e) { deleteFromCompletedRanges('construction') } }"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                                <completed-date-range-btn :from="'construction'" :label="'Κατασκευής'" :status="data.item.value" @selected="updateCompletedRanges" :completed-range="filter['construction']?.completedRange || {}"/>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'MALFUNCTION'].includes(this.filter.type) && weldingStatuses.length > 1"
                            v-model="filter.welding.status"
                            :items="weldingStatuses"
                            item-value="value"
                            item-text="name"
                            :label="statusLabel('Κολλήσεις / Μετρήσεις', 'welding')"
                            clearable
                            outlined
                            class="selection-field status-field"
                            :disabled="disabled"
                            @change="(e) => { if (!e) { deleteFromCompletedRanges('welding') } }"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                                <completed-date-range-btn :from="'welding'" :label="'Κολλήσεων'" :status="data.item.value" @selected="updateCompletedRanges" :completed-range="filter['welding']?.completedRange || {}"/>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'LAST_DROP'].includes(this.filter.type) && otoStatuses.length > 1"
                            v-model="filter.oto.status"
                            :items="otoStatuses"
                            item-value="value"
                            item-text="name"
                            :label="statusLabel('ΟΤΟ', 'oto')"
                            clearable
                            outlined
                            class="selection-field status-field"
                            :disabled="disabled"
                            @change="(e) => { if (!e) { deleteFromCompletedRanges('oto') } }"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                                <completed-date-range-btn :from="'oto'" :label="'ΟΤΟ'" :status="data.item.value" @selected="updateCompletedRanges" :completed-range="filter['oto']?.completedRange || {}"/>
                            </template>
                        </v-select>
                        <v-select
                            v-if=" ['PILOT', 'LAST_DROP'].includes(this.filter.type) && activationStatuses.length > 1"
                            v-model="filter.activation.status"
                            :items="activationStatuses"
                            item-value="value"
                            item-text="name"
                            :label="statusLabel('Ενεργοποίηση', 'activation')"
                            clearable
                            outlined
                            class="selection-field status-field"
                            :disabled="disabled"
                            @change="(e) => { if (!e) { deleteFromCompletedRanges('activation') } }"
                        >
                            <template v-slot:selection="data">
                                <span class="font-weight-bold">{{ data.item.name }}</span>
                                <completed-date-range-btn :from="'activation'" :label="'Ενεργοποίησης'" :status="data.item.value" @selected="updateCompletedRanges" :completed-range="filter['activation']?.completedRange || {}"/>
                            </template>
                        </v-select>
                    </div>
                    <div class="search-button-wrapper">
                        <v-btn v-if="!(this.filter.address || this.filter.clientName || this.filter.sr || this.filter.buildingId)" class="mx-2 white--text search-btn-hover" medium color="black" @click="onSearch">
                            <v-icon medium class="bulding-id-icon">mdi-filter</v-icon> Αναζητηση
                        </v-btn>
                        <v-btn v-if="containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR'], userRoles)" class="mx-2 white--text search-btn-hover" medium color="black" @click="onExport" :loading="exportLoading">
                            <v-icon medium class="bulding-id-icon">mdi-download</v-icon> Export
                        </v-btn>
                    </div>
                </div>
                <div v-else>
                    <div class="assignment-filters">
                        <div class="appointment-filters">
                            <v-select
                                v-model="filter.taskAppointments.type"
                                :items="types"
                                item-value="value"
                                item-text="name"
                                clearable
                                label="Τύπος Ανάθεσης"
                                outlined
                                class="selection-field"
                                :disabled="disabled"
                                @click:clear="() => { delete this.filter.taskAppointments.type; delete this.filter.taskAppointments.taskStatus }"
                                @change="onTypeChange"
                            >
                                <template v-slot:selection="data">
                                    <span class="font-weight-bold">{{ data.item.name }}</span>
                                </template>
                            </v-select>
                            <v-menu
                                v-model="taskAppointmentMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                class="filter-field"
                                :disabled="disabled"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="taskAppointmentFilterDateText"
                                        class="filter-field calendar"
                                        label="Ραντεβού στις"
                                        readonly
                                        clearable
                                        outlined
                                        @click:clear="taskAppointmentFilterDateRange = []"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="disabled"
                                    >
                                        <template v-slot:prepend-inner>
                                            <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="taskAppointmentFilterDateRange"
                                    range
                                    color="#0047AB"
                                    locale="el"
                                    @change="taskAppointmentFilterDateSelected"
                                    @input="() => { if ( taskAppointmentFilterDateRange.length === 2) { taskAppointmentMenu = false }}"
                                    :disabled="disabled"
                                ></v-date-picker>
                            </v-menu>
                            <v-select
                                v-if="isAdminOrCompanyCoordinator"
                                v-model="filter.taskAppointments.contractor"
                                :items="assigneesContractors"
                                item-value="id"
                                item-text="name"
                                label="Ανατεθειμένος Εργολάβος"
                                clearable
                                outlined
                                class="selection-field"
                                @change="onContractorChange"
                                :disabled="disabled"
                            >
                                <template v-slot:selection="data">
                                    <span class="font-weight-bold">{{ data.item.name }}</span>
                                </template>
                            </v-select>
                        </div>
                        <div v-show="isAdminOrCompanyCoordinator" class="appointment-filters">
                            <v-select
                                v-if="shouldShowAssignees"
                                v-model="filter.taskAppointments.assignee"
                                :items="contractorAssignees"
                                item-value="id"
                                :item-text="user => user.firstName + ' ' + user.lastName"
                                label="Υπάλληλος Εργολάβου"
                                clearable
                                outlined
                                multiple
                                class="selection-field"
                                :disabled="disabled"
                            >
                                <template v-slot:selection="data">
                                    <template v-if="data.item">
                                        <v-chip
                                            v-for="role in data.item.roles"
                                            :key="data.item.firstName + data.item.lastName + role.role"
                                            small
                                            :color="getRoleColor(role.role)"
                                            class="role-chip"
                                        >
                                            {{ data.item.firstName }} {{ data.item.lastName }}
                                        </v-chip>
                                    </template>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="data.item">
                                        <v-list-item
                                            v-bind="data.attrs"
                                            @click="data.on.click"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <div class="assignee-name">{{ data.item.firstName }} {{ data.item.lastName }}</div>
                                                </v-list-item-title>
                                            </v-list-item-content>

                                            <v-list-item-action>
                                                <v-chip
                                                    v-for="role in data.item.roles"
                                                    :key="role.role"
                                                    small
                                                    :color="getRoleColor(role.role)"
                                                    class="role-chip"
                                                >
                                                    {{ getRoleText(role.role) }}
                                                </v-chip>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </template>
                                </template>
                            </v-select>
                            <v-select
                                v-model="filter.taskAppointments.status"
                                :items="status"
                                item-value="value"
                                item-text="name"
                                clearable
                                label="Status"
                                outlined
                                multiple
                                class="selection-field appointment-types"
                                :disabled="disabled"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                        class="font-weight-bold white--text"
                                        :color="data.item.color"
                                    >
                                        <v-icon>{{ data.item.icon }}</v-icon>
                                        {{ data.item.name }}
                                    </v-chip>
                                </template>
                            </v-select>
                            <v-select
                                v-model="selectedAppointmentTypes"
                                :items="taskTypes(filter.taskAppointments.type)"
                                item-value="value"
                                item-text="name"
                                label="Τύπος Ραντεβού"
                                clearable
                                outlined
                                multiple
                                class="selection-field appointment-types"
                                @click:clear="() => delete this.filter.taskAppointments.types"
                                @change="onAppointmentTypesChange"
                                :disabled="disabled"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                        class="font-weight-bold"
                                    >
                                        <span class="font-weight-bold">{{ data.item.name }}</span>
                                    </v-chip>
                                </template>
                            </v-select>
                            <div class="appointment-types-status">
                                <v-select
                                    v-for="selectedAppointmentType in this.selectedAppointmentTypes"
                                    :key="selectedAppointmentType"
                                    class="selection-field"
                                    v-model="selectedAppointmentTypeTaskStatuses[selectedAppointmentType]"
                                    :items="taskAssignmentStatuses"
                                    item-value="value"
                                    item-text="name"
                                    clearable
                                    :label="'Κατάσταση Εργασίας για ' + getTaskTypeNameFromValue(selectedAppointmentType)"
                                    outlined
                                    :disabled="disabled"
                                    @clear="() => delete this.selectedAppointmentTypeTaskStatuses[selectedAppointmentType]"
                                >
                                    <template v-slot:selection="data">
                                        <span class="font-weight-bold">{{ data.item.name }}</span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="search-button-wrapper">
                        <v-btn v-if="!(this.filter.address || this.filter.clientName || this.filter.sr || this.filter.buildingId)" class="mx-2 white--text search-btn-hover" medium color="black" @click="onSearch">
                            <v-icon medium class="bulding-id-icon">mdi-filter</v-icon> Αναζητηση
                        </v-btn>
                        <v-btn v-if="containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR'], userRoles)" class="mx-2 white--text search-btn-hover" medium color="black" :loading="exportLoading" @click="onExport">
                            <v-icon medium class="bulding-id-icon">mdi-download</v-icon> Export
                        </v-btn>
                    </div>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>
<script>
    import jwtUtil from '@/utils/jwtUtil'
    import client from '@/services/client'
    import assignmentService from '@/services/assignment'
    import location from '@/services/location'
    import momentTimezone from 'moment-timezone'
    import CompletedDateRangeBtn from '@/components/CompletedDateRangeBtn'
    import FilterPresetCreation from '@/components/FilterPresetCreation'
    import FilterPresetSelection from '@/components/FilterPresetSelection'
    import userService from '@/services/user'
    import userMixin from '@/mixins/user'
    export default {
        components: { CompletedDateRangeBtn, FilterPresetCreation, FilterPresetSelection },
        mixins: [userMixin],
        props: {
            exportLoading: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            'filter.autopsy.status'(newVal, oldVal) {
                if (newVal && this.filter.autopsy?.status !== 'STARTED') {
                    delete this.filter.autopsy.subStatus
                }
            },
            'filter.smartReadiness'(newVal, oldVal) {
                if (!newVal) {
                    delete this.filter.secondTimeSmartReadiness
                }
            },
            'filter.type'(newVal, oldVal) {
                this.clearStepFilters()
                this.filter.smartReadiness = null
                this.filter.secondTimeSmartReadiness = null
                this.filter.excavationDemand = null
                this.filter.excavationPermitted = null
                this.filter.constructionPermitted = null
            },
            'filter.taskAppointments'(newVal, oldVal) {
                if (newVal && Object.keys(newVal).length) {
                    Object.keys(this.filter).forEach(key => {
                        if (key !== 'taskAppointments') {
                            delete this.filter[key]
                        }
                    })
                    Object.keys(this.filter.taskAppointments).forEach(key => {
                        if (!this.filter.taskAppointments[key]) {
                            delete this.filter.taskAppointments[key]
                        }
                    })
                }
            },
            'taskAppointmentFilterDateRange'(newVal, oldVal) {
                if (newVal.length === 0) {
                    delete this.filter.taskAppointments?.finalDatetimeLte
                    delete this.filter.taskAppointments?.finalDatetimeGte
                }
            },
            'filterDateRange'(newVal, oldVal) {
                if (newVal.length === 0) {
                    delete this.filter.assignedToContractorAtLte
                    delete this.filter.assignedToContractorAtGte
                }
            },
            'filterCreatedAtDateRange'(newVal, oldVal) {
                if (newVal.length === 0) {
                    delete this.filter.createdAtLte
                    delete this.filter.createdAtGte
                }
            },
            'filterCompletedAtDateRange'(newVal, oldVal) {
                if (newVal.length === 0) {
                    delete this.filter.completedAtLte
                    delete this.filter.completedAtGte
                }
            }
        },
        computed: {
            taskAssignmentStatuses() {
                return [
                    {
                        name: 'Ολοκληρωμένη',
                        value: 'COMPLETED'
                    },
                    {
                        name: 'Σε Διεκπεραίωση',
                        value: 'ON_GOING'
                    },
                    {
                        name: 'Μη Ολοκληρωμένη',
                        value: 'PENDING'
                    },
                    {
                        name: 'Αναμονή Ραντεβού',
                        value: 'APPOINTMENT_PENDING'
                    }
                ]
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            },
            assignmentViewPreference() {
                return this.$store.getters.getAssignmentViewPreference
            },
            types() {
                return this.config.assignmentTypes
            },
            status() {
                return this.config.assignmentStatuses
            },
            backOfficeStages() {
                return this.config.backOffice?.steps
            },
            stagesPerAssignmentType() {
                return this.config?.stagesPerAssignmentType || {}
            },

            autopsySubStatuses() {
                return this.config?.autopsy?.subStatuses || []
            },
            autopsyStatuses() {
                const autopsyStatuses = [...this.config?.autopsy?.statuses] || []
                autopsyStatuses.push({ name: 'Χωρίς Ραντεβού', value: -1 })
                autopsyStatuses.push({ name: 'Σε διεκπεραίωση', value: 1 })
                return autopsyStatuses
            },
            earthworkStatuses() {
                const earthworkStatuses = [...this.config?.earthwork?.statuses] || []
                earthworkStatuses.push({ name: 'Χωρίς Ραντεβού', value: -1 })
                earthworkStatuses.push({ name: 'Σε διεκπεραίωση', value: 1 })
                return earthworkStatuses
            },
            blowingStatuses() {
                const blowingStatuses = [...this.config?.blowing?.statuses] || []
                blowingStatuses.push({ name: 'Χωρίς Ραντεβού', value: -1 })
                blowingStatuses.push({ name: 'Σε διεκπεραίωση', value: 1 })
                return blowingStatuses
            },
            constructionStatuses() {
                const constructionStatuses = [...this.config?.construction?.statuses] || []
                constructionStatuses.push({ name: 'Χωρίς Ραντεβού', value: -1 })
                constructionStatuses.push({ name: 'Σε διεκπεραίωση', value: 1 })
                return constructionStatuses
            },
            weldingStatuses() {
                const weldingStatuses = [...this.config?.welding?.statuses] || []
                weldingStatuses.push({ name: 'Χωρίς Ραντεβού', value: -1 })
                weldingStatuses.push({ name: 'Σε διεκπεραίωση', value: 1 })
                return weldingStatuses
            },
            otoStatuses() {
                const otoStatuses = [...this.config?.oto?.statuses] || []
                otoStatuses.push({ name: 'Χωρίς Ραντεβού', value: -1 })
                otoStatuses.push({ name: 'Σε διεκπεραίωση', value: 1 })
                return otoStatuses
            },
            activationStatuses() {
                const activationStatuses = [...this.config?.activation?.statuses] || []
                activationStatuses.push({ name: 'Χωρίς Ραντεβού', value: -1 })
                activationStatuses.push({ name: 'Σε διεκπεραίωση', value: 1 })
                return activationStatuses
            },
            areLikeFiltersClear() {
                if (!this.filter.sr && !this.filter.buildingId && !this.filter.address && !this.filter.clientName) {
                    return true
                }
                return false
            },
            getSizeFromRouteQuery() {
                const routeQuery = this.$route.query
                if (routeQuery && routeQuery.size && !isNaN(routeQuery.size)) {
                    return parseInt(routeQuery.size)
                }
                return 5
            },
            getPageFromRouteQuery() {
                const routeQuery = this.$route.query
                if (routeQuery && routeQuery.page && !isNaN(routeQuery.page)) {
                    return parseInt(routeQuery.page)
                }
                return 1
            }
        },
        data() {
            return {
                userFilterPresets: [],
                sort: ['age', 'DESC'],
                filterToSave: {},
                completedDateRanges: {},
                backOfficeFilterSelection: [],
                sortBy: null,
                panel: undefined,
                assigneesContractors: [],
                assignorsContractors: [],
                locations: [],
                clients: [],
                contractorAssignees: [],
                aks: [],
                filterDateRange: [],
                filterCreatedAtDateRange: [],
                filterCompletedAtDateRange: [],
                taskAppointmentFilterDateRange: [],
                selectedAppointmentTypes: [],
                selectedAppointmentTypeTaskStatuses: {},
                filterDateText: '',
                filterCreatedAtDateText: '',
                filterCompletedAtDateText: '',
                taskAppointmentFilterDateText: '',
                menu: false,
                shouldShowAssignees: false,
                createdAtMenu: false,
                completedAtMenu: false,
                taskAppointmentMenu: false,
                selectedTab: 0,
                booleanOptions: [
                    {
                        text: 'Ναι',
                        value: true
                    },
                    {
                        text: 'Όχι',
                        value: false
                    }
                ],
                prodesmeusiDifferenceStages: [
                    {
                        name: 'Εμφύσηση',
                        value: 'blowing'
                    },
                    {
                        name: 'Κατασκευή',
                        value: 'construction'
                    },
                    {
                        name: 'Κολλήσεις/Μετρήσεις',
                        value: 'welding'
                    }
                ],
                freeSearchSortSelections: [
                    { text: 'Age', value: 'age' },
                    { text: 'Priority', value: 'priority' },
                    { text: 'Status', value: 'status' },
                    { text: 'Ανάθεση σε εργολάβο', value: 'assignedToContractorAt' },
                    { text: 'Όνομα Πελάτη', value: 'clientName' },
                    { text: 'Building Id', value: 'buildingId' },
                    { text: 'A/K', value: 'ak' },
                    { text: 'Περιοχή', value: 'location' },
                    { text: 'Διέυθυνση', value: 'address' },
                    { text: 'Τύπο', value: 'type' },
                    { text: 'Δημιουργία', value: 'createdAt' }
                ],
                sortSelections: [
                    { text: 'Age', value: 'age' },
                    { text: 'Priority', value: 'priority' },
                    { text: 'Ημ/νία Κατασκευής', value: 'constructionDate' },
                    { text: 'Status', value: 'status' },
                    { text: 'Ανάθεση σε εργολάβο', value: 'assignedToContractorAt' },
                    { text: 'Όνομα Πελάτη', value: 'clientName' },
                    { text: 'Building Id', value: 'buildingId' },
                    { text: 'A/K', value: 'ak' },
                    { text: 'Περιοχή', value: 'location' },
                    { text: 'Διέυθυνση', value: 'address' },
                    { text: 'Τύπο', value: 'type' },
                    { text: 'Δημιουργία', value: 'createdAt' }
                ],
                tabs: [
                    {
                        text: 'ΕΛΕΥΘΕΡΗ ΑΝΑΖΗΤΗΣΗ',
                        value: 'freeSearch'
                    },
                    {
                        text: 'ΑΝΑΖΗΤΗΣΗ ΜΕ ΕΠΙΛΟΓΕΣ',
                        value: 'selectionSearch'
                    },
                    {
                        text: 'ΑΝΑΖΗΤΗΣΗ ΜΕ ΡΑΝΤΕΒΟΥ',
                        value: 'appointmentSearch'
                    }
                ],
                selectedPresetFilter: null,
                filter: {},
                disabled: false,
                sortType: 'ASC',
                likeFilterFields: ['address', 'sr', 'buildingId', 'clientName'],
                stepFilterFields: ['autopsy', 'earthwork', 'blowing', 'construction', 'welding', 'oto', 'activation'],
                restFilterFields: ['smartReadiness', 'status', 'prodesmeusiDifference', 'location', 'aks', 'contractor', 'type', 'assignedToContractorAtLte', 'assignedToContractorAtGte', 'createdAtLte', 'createdAtGte', 'completedAtLte', 'completedAtGte', 'notFromImport', 'backOffice', 'excavationDemand', 'excavationPermitted', 'constructionPermitted']
            }
        },
        created() {
            this.getCurrentUser()
            this.getAllClients()
            this.getAllLocations()
            const storedFilter = JSON.parse(sessionStorage.getItem('assignment-filters')) || {}
            const storedSort = JSON.parse(sessionStorage.getItem('sort')) || ['age', 'DESC']
            const storedPresetFilter = JSON.parse(sessionStorage.getItem('preset-filter')) || null
            this.initFilters(storedFilter, storedSort, storedPresetFilter)
            this.getAllAks()
        },
        methods: {
            async getContractorUsers(contractorId) {
                const resp = await userService.getContractorUsers(contractorId)
                this.contractorAssignees = resp.data.filter(assignee => assignee.roles.some(role => role.role !== 'ROLE_COORDINATOR'))
            },
            async getCurrentUser() {
                const resp = await userService.getCurrentUser()
                this.currentUser = resp.data
                this.userFilterPresets = this.currentUser?.filterPresets || []
            },
            onAppointmentTypesChange() {
                Object.keys(this.selectedAppointmentTypeTaskStatuses).forEach(key => {
                    if (!this.selectedAppointmentTypes.includes(key)) {
                        this.$delete(this.selectedAppointmentTypeTaskStatuses, key)
                    }
                })
            },
            getTaskTypeNameFromValue(taskTypeValue) {
                return this.stagesPerAssignmentType['PILOT'].find(stage => stage.value === taskTypeValue)?.name
            },
            taskTypes(type) {
                if (!this.stagesPerAssignmentType) return []
                switch (type) {
                case 'PILOT':
                    return this.stagesPerAssignmentType['PILOT'].filter(stage => stage.value !== 'backOffice')
                case 'LAST_DROP':
                    return this.stagesPerAssignmentType['LAST_DROP'].filter(stage => stage.value !== 'backOffice')
                case 'MALFUNCTION':
                    return this.stagesPerAssignmentType['MALFUNCTION'].filter(stage => stage.value !== 'backOffice')
                case 'PILOT_UFBB':
                    return this.stagesPerAssignmentType['PILOT'].filter(stage => stage.value !== 'backOffice')
                default:
                    return this.stagesPerAssignmentType['PILOT'].filter(stage => stage.value !== 'backOffice')
                }
            },
            getAllAks() {
                assignmentService.getAllAks().then(resp => { this.aks = resp.data })
            },
            statusLabel(text, value) {
                return !this.completedDateRanges[value] ? text : text + ' ' + this.completedDateRanges[value].text
            },
            deleteFromCompletedRanges(stage) {
                this.$delete(this.completedDateRanges, stage)
                if (this.filter[stage]) {
                    delete this.filter[stage].completedRange
                }
            },
            updateCompletedRanges(e) {
                if (e.range.length === 2) {
                    this.$set(this.completedDateRanges, e.from, { range: e.range, text: e.text })
                } else {
                    this.$delete(this.completedDateRanges, e.from)
                }
            },
            selectTab() {
                if (this.sortBy === 'constructionDate') {
                    this.sortBy = 'age'
                }
                this.clearFilters()
            },
            shouldTabBeDisabled(tab) {
                const isAppointmentSearch = (this.filter.taskAppointments && Object.keys(this.filter.taskAppointments).length > 0) || this.selectedAppointmentTypes.length > 0 || this.taskAppointmentFilterDateRange.length > 0
                if (((tab.value === 'selectionSearch' || tab.value === 'appointmentSearch') && !this.areLikeFiltersClear) ||
                    ((tab.value === 'selectionSearch' || tab.value === 'freeSearch') && isAppointmentSearch)) {
                    return true
                } else {
                    return false
                }
            },
            toggleClearButton() {
                this.clearFilters()
                this.removePresetFilter()
                this.onSearch()
            },
            clearStepFilters() {
                this.filter.autopsy = { status: null, subStatus: null }
                this.filter.earthwork = { status: null }
                this.filter.welding = { status: null }
                this.filter.blowing = { status: null }
                this.filter.construction = { status: null }
                this.filter.oto = { status: null }
                this.filter.activation = { status: null }
                this.filter.backOffice = null
            },
            clearFilters() {
                this.selectedPresetFilter = null
                this.filterToSave = {}
                this.filterDateText = ''
                this.filterCreatedAtDateText = ''
                this.filterCompletedAtDateText = ''
                this.taskAppointmentFilterDateText = ''
                this.filter.sr = null
                this.filter.address = null
                this.filter.clientName = null
                this.filter.buildingId = null
                this.filter.excavationDemand = null
                this.filter.excavationPermitted = null
                this.filter.constructionPermitted = null
                this.filter.notFromImport = null
                this.filter.smartReadiness = null
                this.filter.secondTimeSmartReadiness = null
                this.filter.status = null
                this.filter.prodesmeusiDifference = null
                this.filter.location = []
                this.filter.aks = []
                this.filter.contractor = null
                this.filter.contractorFrom = null
                this.filter.type = null
                this.filter.assignedToContractorAtLte = null
                this.filter.assignedToContractorAtGte = null
                this.filter.completedAtLte = null
                this.filter.completedAtGte = null
                this.filter.createdAtLte = null
                this.filter.createdAtGte = null
                this.filterDateRange = []
                this.filterCreatedAtDateRange = []
                this.filterCompletedAtDateRange = []
                this.backOfficeFilterSelection = []
                this.selectedAppointmentTypes = []
                this.selectedAppointmentTypeTaskStatuses = {}
                this.taskAppointmentFilterDateRange = []
                this.filter.taskAppointments = {}
                this.filter.lastDropDoubleCrew = null
                this.filter.lastDropEnrichment = null
                this.completedDateRanges = {}
                this.clearStepFilters()
            },
            deepMerge(target, source) {
                for (const key in source) {
                    if (
                        source[key] instanceof Object &&
                        key in target &&
                        target[key] instanceof Object
                    ) {
                        this.deepMerge(target[key], source[key])
                    } else {
                        target[key] = source[key]
                    }
                }
                return target
            },
            initFilters(storedFilter, storedSort, storedPreset) {
                this.clearFilters()
                if (storedSort.length > 0) {
                    this.sortBy = storedSort[0]
                    this.sortType = storedSort[1]
                }
                if (storedPreset && storedPreset.filter) {
                    storedFilter = storedPreset.filter
                    this.filterToSave = null
                    this.selectedPresetFilter = storedPreset
                } else if (storedFilter && Object.keys(storedFilter).length > 1 && !this.filterHasOnlyClient(storedFilter)) {
                    this.filterToSave = storedFilter
                }
                this.filter = this.deepMerge(this.filter, storedFilter)
                this.selectedTab = 0
                let shouldOpenFilters = false
                if (this.filter.backOffice?.length > 0) {
                    this.backOfficeFilterSelection = this.filter.backOffice.map(filter => Object.keys(filter)[0])
                    shouldOpenFilters = true
                    this.selectedTab = 1
                }
                this.likeFilterFields.forEach(field => {
                    if (storedFilter[field]) {
                        this.filter[field] = storedFilter[field].replaceAll('%', '')
                        shouldOpenFilters = true
                    }
                })
                this.restFilterFields.forEach(field => {
                    if (storedFilter[field]) {
                        shouldOpenFilters = true
                        this.selectedTab = 1
                    }
                })
                this.stepFilterFields.forEach(field => {
                    if (storedFilter[field]?.completedRange) {
                        this.completedDateRanges[field] = {}
                        this.completedDateRanges[field].text = storedFilter[field].completedRange.text
                        this.completedDateRanges[field].range = storedFilter[field].completedRange.range
                        shouldOpenFilters = true
                        this.selectedTab = 1
                    }
                })
                if (this.filter.taskAppointments?.types) {
                    this.selectedAppointmentTypes = this.filter.taskAppointments.types
                    if (this.filter.taskAppointments?.taskStatus) {
                        this.selectedAppointmentTypeTaskStatuses = this.filter.taskAppointments.taskStatus
                    }
                    shouldOpenFilters = true
                    this.selectedTab = 2
                }
                if (this.filter.taskAppointments?.contractor || this.filter.taskAppointments?.type || this.filter.taskAppointments?.status) {
                    shouldOpenFilters = true
                    this.selectedTab = 2
                }
                if (this.filter.assignedToContractorAtLte && this.filter.assignedToContractorAtGte) {
                    const gte = momentTimezone(this.filter.assignedToContractorAtGte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    const lte = momentTimezone(this.filter.assignedToContractorAtLte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    this.filterDateRange = [gte, lte]
                    this.filterDateText = gte.toString() + ' ~ ' + lte.toString()
                }
                if (this.filter.createdAtLte && this.filter.createdAtGte) {
                    const gte = momentTimezone(this.filter.createdAtGte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    const lte = momentTimezone(this.filter.createdAtLte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    this.filterCreatedAtDateRange = [gte, lte]
                    this.filterCreatedAtDateText = gte.toString() + ' ~ ' + lte.toString()
                }
                if (this.filter.completedAtLte && this.filter.completedAtGte) {
                    const gte = momentTimezone(this.filter.completedAtGte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    const lte = momentTimezone(this.filter.completedAtLte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    this.filterCompletedAtDateRange = [gte, lte]
                    this.filterCompletedAtDateText = gte.toString() + ' ~ ' + lte.toString()
                }
                if (this.filter.taskAppointments?.finalDatetimeLte && this.filter.taskAppointments?.finalDatetimeGte) {
                    const gte = momentTimezone(this.filter.taskAppointments.finalDatetimeGte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    const lte = momentTimezone(this.filter.taskAppointments.finalDatetimeLte).tz('Europe/Athens').utc().format('YYYY-MM-DD')
                    this.taskAppointmentFilterDateRange = [gte, lte]
                    this.taskAppointmentFilterDateText = gte.toString() + ' ~ ' + lte.toString()
                    shouldOpenFilters = true
                    this.selectedTab = 2
                }
                if (this.filter.taskAppointments?.contractor) {
                    this.getContractorUsers(this.filter.taskAppointments.contractor)
                    this.shouldShowAssignees = true
                }
                if (this.sortBy === 'constructionDate') {
                    shouldOpenFilters = true
                    this.selectedTab = 1
                }
                if (shouldOpenFilters) {
                    this.openPanel()
                }
            },
            onContractorChange(contractorId) {
                if (!contractorId) {
                    this.shouldShowAssignees = false
                    delete this.filter.taskAppointments.contractor
                    delete this.filter.taskAppointments.assignee
                    return
                }
                delete this.filter.taskAppointments.assignee
                this.getContractorUsers(contractorId)
                this.shouldShowAssignees = true
            },
            onAssigneeChange(e) {
                if (e === null || e === undefined) {
                    delete this.filter.taskAppointments.assignee
                }
                this.onSearch()
            },
            toggleSortType() {
                if (this.sortType === 'ASC') {
                    this.sortType = 'DESC'
                } else {
                    this.sortType = 'ASC'
                }
                this.onSearch()
            },
            likeFieldTriggered() {
                Object.keys(this.filter).forEach(key => {
                    if (!this.likeFilterFields.includes(key)) {
                        delete this.filter[key]
                    }
                })
                this.selectedAppointmentTypes = []
                this.taskAppointmentFilterDateRange = []
                this.onSearch()
            },
            togglePanel() {
                const curr = this.panel
                this.panel = curr === undefined ? 0 : undefined
            },
            openPanel() {
                this.panel = 0
            },
            disableFilters() {
                this.filter = {}
                this.disabled = true
                this.filterDateRange = []
                this.filterCreatedAtDateRange = []
                this.filterCompletedAtDateRange = []
                this.filterDateText = ''
                this.filterCreatedAtDateText = ''
                this.filterCompletedAtDateText = ''
                this.taskAppointmentFilterDateText = ''
            },
            createAssignment() {
                this.$router.push(`/assignments/create`)
            },
            getProccessedFilter() {
                let filter = { ...this.filter }
                Object.keys(this.completedDateRanges).forEach(key => {
                    filter[key].completedRange = { range: this.completedDateRanges[key].range, text: this.completedDateRanges[key].text }
                })
                if (filter.sr) {
                    filter.sr = filter.sr + '%'
                }
                if (filter.address) {
                    filter.address = '%' + filter.address + '%'
                }
                if (filter.buildingId) {
                    filter.buildingId = filter.buildingId + '%'
                }
                if (filter.clientName) {
                    filter.clientName = '%' + filter.clientName + '%'
                }
                if (filter.location?.length === 0) {
                    delete filter.location
                }
                if (filter.status?.length === 0) {
                    delete filter.status
                }
                if (this.backOfficeFilterSelection.length > 0) {
                    filter.backOffice = []
                    for (let value of this.backOfficeFilterSelection) {
                        const obj = {}
                        obj[value] = false
                        filter.backOffice.push(obj)
                    }
                }
                if (this.selectedAppointmentTypes.length > 0 || this.taskAppointmentFilterDateRange.length > 0 || this.filter.taskAppointments?.contractor) {
                    filter.taskAppointments = filter.taskAppointments || {}
                    Object.keys(filter).forEach(key => {
                        if (key !== 'taskAppointments') {
                            delete filter[key]
                        }
                    })
                }

                if (this.selectedAppointmentTypes.length > 0) {
                    filter.taskAppointments.types = this.selectedAppointmentTypes
                } else {
                    delete filter.taskAppointments?.types
                    delete filter.taskAppointments?.taskStatus
                }
                if (this.taskAppointmentFilterDateRange.length === 0) {
                    delete filter.taskAppointments?.finalDatetimeGte
                    delete filter.taskAppointments?.finalDatetimeLte
                }
                if (Object.keys(this.selectedAppointmentTypeTaskStatuses).length > 0) {
                    Object.keys(this.selectedAppointmentTypeTaskStatuses).forEach(key => {
                        if (!this.selectedAppointmentTypeTaskStatuses[key]) {
                            delete this.selectedAppointmentTypeTaskStatuses[key]
                        }
                    })
                    if (Object.keys(this.selectedAppointmentTypeTaskStatuses).length === 0) {
                        delete filter.taskAppointments?.taskStatus
                    } else {
                        filter.taskAppointments.taskStatus = this.selectedAppointmentTypeTaskStatuses
                    }
                } else {
                    delete filter.taskAppointments?.taskStatus
                }

                if (filter.taskAppointments?.status?.length === 0) {
                    delete filter.taskAppointments?.status
                }

                if (this.sortBy) {
                    this.sort = [this.sortBy, this.sortType]
                } else {
                    this.sort = ['age', 'DESC']
                }

                Object.keys(filter).forEach(key => {
                    if (typeof filter[key] === 'number' || typeof filter[key] === 'boolean') {
                        return
                    }
                    if (filter[key] && typeof filter[key] === 'object') {
                        Object.keys(filter[key]).forEach(subkey => {
                            if (!filter[key][subkey]) {
                                delete filter[key][subkey]
                            }
                        })
                    }
                    if (!filter[key] || (filter[key] && Object.keys(filter[key]).length === 0) || (filter[key] !== null && filter[key]?.status === null)) {
                        delete filter[key]
                    }
                })

                return filter
            },
            stableStringify(obj) {
                return JSON.stringify(obj, Object.keys(obj).sort())
            },
            isEqual(a, b) {
                return this.stableStringify(a) === this.stableStringify(b)
            },
            onApplyFilterPreset(preset) {
                this.initFilters(preset.filter, preset.sort, null)
                this.selectedPresetFilter = preset
                this.filterToSave = null
                this.$emit('search', this.getProccessedFilter(), this.sort)
                sessionStorage.setItem('preset-filter', JSON.stringify(preset))
            },
            removePresetFilter() {
                this.selectedPresetFilter = null
                sessionStorage.removeItem('preset-filter')
            },
            onSearch() {
                if (this.getPageFromRouteQuery !== 1) {
                    this.$router.push({ query: { page: 1, size: this.getSizeFromRouteQuery } })
                }
                const filter = this.getProccessedFilter()
                this.$emit('search', filter, this.sort)
                if (this.selectedPresetFilter !== null &&
                    Object.keys(this.selectedPresetFilter.filter).length > 0 &&
                    !this.isEqual(this.selectedPresetFilter.filter, filter)) {
                    this.removePresetFilter()
                }
                if (!this.selectedPresetFilter && !this.filterHasOnlyClient(filter)) {
                    this.filterToSave = filter
                }
            },
            filterHasOnlyClient(filter) {
                return Object.keys(filter).length === 1 && Object.prototype.hasOwnProperty.call(filter, 'client')
            },
            onExport() {
                const filter = this.getProccessedFilter()
                this.$emit('export', filter, this.sort)
            },
            getAllClients() {
                this.assigneesContractors = []
                this.assignorsContractors = []
                client.getAllClients().then(resp => {
                    this.clients = resp.data
                    const contractors = this.clients.flatMap(client => client.contractors)
                    this.assigneesContractors = contractors.filter(contractor => contractor.assignee === true)
                    this.assigneesContractors.push({ id: -1, name: 'Κανένας' })

                    if (this.clients.length === 1) {
                        this.filter.client = this.clients[0].id
                        this.onClientSelect(this.clients[0].id)
                    }
                })
            },
            changeView() {
                if (this.assignmentViewPreference === 'array') {
                    this.$store.dispatch('setAssignmentViewPreference', 'cards')
                } else {
                    this.$store.dispatch('setAssignmentViewPreference', 'array')
                }
            },
            onTypeChange(e) {
                this.clearStepFilters()
                this.selectedAppointmentTypes = []
                this.selectedAppointmentTypeTaskStatuses = {}
                this.filter = { ...this.filter }
            },
            getAllLocations() {
                location.getAll().then(resp => {
                    this.locations = resp.data
                    this.locations.push({ id: null, name: 'Χωρίς Περιοχή' })
                })
            },
            filterDateSelected(dateRange) {
                this.filterDateText = dateRange[0] + ' ~ ' + dateRange[1]
                this.filter.assignedToContractorAtGte = momentTimezone(dateRange[0] + ' 00:00:00').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.filter.assignedToContractorAtLte = momentTimezone(dateRange[1] + ' 23:59:59').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
            },
            filterCreatedAtDateSelected(dateRange) {
                this.filterCreatedAtDateText = dateRange[0] + ' ~ ' + dateRange[1]
                this.filter.createdAtGte = momentTimezone(dateRange[0] + ' 00:00:00').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.filter.createdAtLte = momentTimezone(dateRange[1] + ' 23:59:59').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
            },
            filterCompletedAtDateSelected(dateRange) {
                this.filterCompletedAtDateText = dateRange[0] + ' ~ ' + dateRange[1]
                this.filter.completedAtGte = momentTimezone(dateRange[0] + ' 00:00:00').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.filter.completedAtLte = momentTimezone(dateRange[1] + ' 23:59:59').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
            },
            taskAppointmentFilterDateSelected(dateRange) {
                this.taskAppointmentFilterDateText = dateRange[0] + ' ~ ' + dateRange[1]
                this.filter.taskAppointments = this.filter.taskAppointments || {}
                this.filter.taskAppointments.finalDatetimeGte = momentTimezone(dateRange[0] + ' 00:00:00').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                this.filter.taskAppointments.finalDatetimeLte = momentTimezone(dateRange[1] + ' 23:59:59').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            },
            onClientSelect(clientId) {
                const selectedClient = this.clients.find(client => client.id === clientId)
                if (selectedClient) {
                    this.assignorsContractors = selectedClient.contractors.filter(contractor => contractor.assignor === true)
                    this.assignorsContractors.push({ id: -1, name: 'Κανένας' })
                } else {
                    this.assignorsContractors = []
                }
            }
        }
    }
</script>
<style>
.v-expansion-panel-header__icon {
    display: none !important;
}
.status-field .v-select__selections input[type="text"] {
  display: none !important;
}
.status-field .v-select__selections {
  display: flex;
  justify-content: space-between;
}
.selection-field .v-text-field__details {
  display: none !important;
}
.filter-field .v-text-field__details {
  display: none !important;
}
.sort-wrapper .v-text-field__details {
    display: none !important;
}
.locations .v-text-field__details {
    display: none !important;
}
</style>
<style scoped>

.free-search-wrapper {
    margin-top: 0.7rem;
}

.filter-remove:hover {
    color: red !important;
}

.filter-icon:hover {
    color: #febf15 !important;
}
.change-view-icon:hover {
    color: #3d8037 !important;
}
.search-btn-hover:hover .v-icon {
    color: #febf15 !important;
}
.search-btn-hover {
    transition: 0.25s ease;
}
.search-btn-hover:hover {
    box-shadow: 0 6px 16px rgba(0,0,0,0.18);
}
.search-btn-hover:active {
    transform: translateY(0);
    box-shadow: 0 3px 10px rgba(0,0,0,0.15);
}
.role-chip {
    color: white;
    margin-left: 0.3rem;
}
.selected-preset-filter {
    display: flex;
    justify-content: center;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    font-size: 1rem;
}
.selected-preset-filter-text {
    color: var(--cards-and-tables-text-color) !important;
    margin-left: 0.5rem;
}
.appointment-filters {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
}
.filter-buttons-title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
}
.filter-buttons-selections {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
.filter-buttons, .sort-wrapper, .create-new {
    flex: 1 1 33.33%;
}
.filter-buttons {
    font-size: 1.4rem;
    align-items: center;
    min-width: 270px;
    display: flex;
    flex-wrap: wrap;
}
.create-new {
    display: flex;
    justify-content: flex-end;
}
.sort-by-selection {
    margin-left: 0.5rem
}
.expansion-panel {
    max-width: 90%;
    margin: 0 auto;
}
.assignment-filters {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-top: 0.8rem;
    max-width: 1200px;
    margin: 0 auto;
}
.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}
.filters-panel {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}

.sort-wrapper {
    display: flex;
    align-items: center;
    min-width: 200px;
}

.more-filters-button-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    align-items: center;
}

.selection-field, .status-field {
    flex: 1 1 350px;
    max-width: 400px !important;
    width: 100%;
    padding: 0.5rem;
}

.locations {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0.5rem;
}

.filter-field {
    padding: 0.5rem;
}

.filter-field.calendar {
    flex: 1 1 350px;
    max-width: 400px;
    width: 100%;
    margin: 0;
}

.filter-field.client-name {
    min-width: 270px;
}

.filter-field.sr {
    min-width: 270px;
}
.filter-field.address {
    min-width: 270px;
}
.filter-field.building-id {
    min-width: 270px;
}

.search-button-wrapper {
    display: flex;
    justify-content: center;
}

.bulding-id-icon {
    color: #0000A3;
}

.card-title-2 {
    font-weight: 500;
    font-size: 1.25rem;
}

.like-search-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.5rem;
}

@media only screen and (max-width: 1085px) {
    .create-new {
        justify-content: center;
    }
}
.appointment-types {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 auto;
    padding-bottom: 0.8rem;
}
.appointment-types-status {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
    padding-bottom: 0.8rem;
}
.filter-preset {
    z-index: 100;
}
</style>
